module.exports = __webpack_public_path__ + "static/media/Bed Bath and Beyond.2bddca8c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bed Bath and Beyond.svg
// module id = 167
// module chunks = 0